import { render } from "./AppBanner.vue?vue&type=template&id=3d64d554"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\Projects\\2025_ostrowskiortopeda_pl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__